import { supabase } from '../../lib/supabase';

export const leadsAPI = {
  async addLead(leadData) {
    try {
      // Map camelCase JS fields to snake_case Supabase columns
      const mapped = {
        first_name: leadData.firstName || null,
        last_name: leadData.lastName || null,
        email: leadData.email || null,
        phone: leadData.phone || null,
        lead_type: leadData.leadType || 'information',
        lead_source: leadData.leadSource || 'website',
        message: leadData.message || null,
        preferred_contact_method: leadData.preferredContactMethod || 'email',
        preferred_contact_time: leadData.preferredContactTime || null,
        vehicle_make: leadData.vehicleMake || null,
        vehicle_model: leadData.vehicleModel || null,
        vehicle_year: leadData.vehicleYear || null,
        interested_vehicle_id: leadData.interestedVehicleId || null,
        budget_min: leadData.budgetMin || null,
        budget_max: leadData.budgetMax || null,
        financing_needed: leadData.financingNeeded || false,
        trade_in_make: leadData.tradeInMake || null,
        trade_in_model: leadData.tradeInModel || null,
        trade_in_year: leadData.tradeInYear || null,
        trade_in_mileage: leadData.tradeInMileage || null,
        trade_in_condition: leadData.tradeInCondition || null,
        status: 'new',
        priority: 'medium',
        created_at: new Date().toISOString()
      };

      const { data, error } = await supabase
        .from('leads')
        .insert([mapped])
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error adding lead:', error);
      return { data: null, error };
    }
  },

  async getLeads() {
    try {
      const { data, error } = await supabase
        .from('leads')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching leads:', error);
      return { data: null, error };
    }
  },

  async updateLead(id, updates) {
    try {
      const { data, error } = await supabase
        .from('leads')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error updating lead:', error);
      return { data: null, error };
    }
  },

  async deleteLead(id) {
    try {
      const { error } = await supabase
        .from('leads')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error deleting lead:', error);
      return { error };
    }
  }
};
